"use client";
import Button from "@/components/Cards/Button";
import { TextInput } from "@/components/Inputs/TextInput";
import InfoModal from "@/components/Modal";
import Text from "@/components/Text/Text";
import { ButtonDark, MdButton } from "@/stories/Button.stories";
import { Group, Radio } from "@mantine/core";
import { useForm, zodResolver } from "@mantine/form";
import { useState } from "react";
import { z } from "zod";
import ErrorModal from "../ErrorModal";

export default function KontaktForm({
    sendEmail,
}: {
    sendEmail: (subject: string, data: object) => Promise<void>;
}) {
    const [openModal, setOpenModal] = useState(false);
    const [error, setError] = useState(false);
    const schema = z.object({
        request: z.string(),
        anrede: z.string(),
        name: z.string(),
        surname: z.string(),
        email: z
            .string()
            .email()
            .refine((email) => email.length > 0, {
                message: "Bitte geben Sie eine gültige E-Mail-Adresse ein",
            }),
        phone: z.string(),
    });
    const form = useForm({
        initialValues: {
            request: "",
            anrede: "",
            name: "",
            surname: "",
            email: "",
            phone: "",
        },
        validate: zodResolver(schema),
    });

    return (
        <>
            <div className="lg:w-1/3">
                <Text
                    hasPretitle={false}
                    title="Wie kann ich dir weiterhelfen?"
                    hasText={true}
                    textColor="text-black"
                    paragraphs={[
                        "Schieb deine Frage nicht länger auf und schreib mir einfach eine E-Mail. In der Regel erhältst innerhalb eines Tages Antwort, spätestens jedoch in 48 Stunden. ",
                    ]}
                    paddings="px-5 lg:py-0  py-5 w-full"
                    leading="leading-10 lg:leading-14"
                    leadingText="leading-7 lg:leading-8.5"
                />
                <div className="py-5 px-5">
                    <div className=" text-black text-xl lg:text-xl1 font-bold  leading-8.5">
                        Ich freue mich auf deine Anfrage.
                    </div>
                    <div className=" text-black text-xl lg:text-xl1 font-bold  leading-8.5">
                        Rico Brunner
                    </div>
                </div>
                <form
                    className="space-y-3 px-5"
                    onSubmit={form.onSubmit((values) => {
                        const data = {
                            anrede: values.anrede,
                            name: values.name,
                            surname: values.surname,
                            email: values.email,
                            phone: values.phone,
                            request: values.request,
                        };
                        sendEmail("Kontakt", data)
                            .then(() => {
                                setOpenModal(true);
                            })
                            .catch((e) => {
                                <ErrorModal
                                    open={error}
                                    onClose={() => setError(false)}
                                />;
                            });
                    })}
                >
                    <div>
                        <TextInput
                            type="textarea"
                            id="request"
                            name="request"
                            placeholder="Hier eingeben"
                            label="Dein Anliegen"
                            backgroundColor="bg-yellow"
                            height="min-h-36"
                            {...form.getInputProps("request")}
                        />
                    </div>
                    <p className="grow shrink basis-0 text-neutral-800 lg:text-lg text-base font-bold  leading-tight">
                        Anrede
                    </p>
                    <Radio.Group
                        id="anrede"
                        name="anrede"
                        className="text-neutral-800 text-base font-bold  leading-tight"
                        {...form.getInputProps("anrede")}
                    >
                        <Group mt="xs">
                            <Radio value="frau" label="Frau" />
                            <Radio value="herr" label="Herr" />
                            <Radio value="divers" label="Divers" />
                        </Group>
                    </Radio.Group>

                    <TextInput
                        id="name"
                        name="name"
                        type="text"
                        placeholder="Hier eingeben"
                        label="Vorname"
                        backgroundColor="bg-yellow"
                        {...form.getInputProps("name")}
                    />
                    <TextInput
                        id="surname"
                        name="surname"
                        type="text"
                        placeholder="Hier eingeben"
                        label="Nachname"
                        backgroundColor="bg-yellow"
                        {...form.getInputProps("surname")}
                    />
                    <TextInput
                        id="email"
                        name="email"
                        type="email"
                        placeholder="Hier eingeben"
                        label="E-Mail"
                        backgroundColor="bg-yellow"
                        {...form.getInputProps("email")}
                    />
                    <TextInput
                        id="phone"
                        name="phone"
                        type="text"
                        placeholder="Hier eingeben"
                        label="Telefonnummer"
                        backgroundColor="bg-yellow"
                        {...form.getInputProps("phone")}
                    />
                    <Button
                        backgroundColor={MdButton.args?.backgroundColor}
                        size={""}
                        hasIcon={MdButton.args?.hasIcon}
                        text="KONTAKT AUFNEHMEN"
                        paddings={"px-3 py-4"}
                        rounded={MdButton.args?.rounded}
                        textColor={MdButton.args?.textColor}
                        textSize={MdButton.args?.textSize}
                    />
                </form>
                <InfoModal
                    onClose={() => setOpenModal(false)}
                    opened={openModal}
                    size="xl"
                >
                    <>
                        <Text
                            hasPretitle={false}
                            hasSubTitle={false}
                            hasText={true}
                            paddings=""
                            title="Danke für deine Nachricht!"
                            paragraphs={[
                                "Ich habe deine Anfrage erhalten. Ich melde mich so schnell als möglich bei dir. In der Regel werden die Nachrichten innerhalb eines Tages beantwortet, spätestens jedoch in 48 Stunden.",
                                "Liebe Grüsse",
                                "Rico Brunner",
                            ]}
                        />
                        <div className="flex py-5 justify-end">
                            <Button
                                size={ButtonDark.args?.size}
                                backgroundColor={ButtonDark.args?.backgroundColor}
                                hasIcon={ButtonDark.args?.hasIcon}
                                text="Home"
                                textColor={ButtonDark.args?.textColor}
                                textSize={ButtonDark.args?.textSize}
                                as="a"
                                href="/"
                            />
                        </div>
                    </>
                </InfoModal>
            </div>
        </>
    );
}
